<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1.แผนการดำเนินงานวิจัย (จัดทำในรูปเเบบ Project based management)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button theme="6" :disabled="partOneEditMode" @onClick="addNewPlan">
              + เพิ่มแผนดำเนินงาน
            </Button>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                จัดการ
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="allPlans && allPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in allPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{
                  'plan-active':
                    partOneEditMode && tempPlan && tempPlan.temp_index === i,
                }"
              >
                <div class="d-flex justify-space-between align-center" style="min-width: 42px; max-width: 42px">
                  <v-btn small icon @click="editPlan(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn small icon @click="deletePlan(i)">
                    <Iconify
                        icon="material-symbols:delete"
                        color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <!-- <div
                  class="flex two-line"
                  style="min-width: 120px; max-width: 120px; max-height: 45px"
                >
                  {{ item.p1_activity_name }}
                </div> -->
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in item.project_section_plan_month"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ m.month_value ? m.month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ m.actual_month_value ? m.actual_month_value : "-" }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="mt-3"></v-divider>

                <div class="d-flex justify-space-between align-center gap-8 py-3" 
                    :class="{ 'bg-error': !validatePlanBudget() }" 
                >
                  <div class="flex" style="min-width: 42px; max-width: 42px">
                    <v-btn
                      v-if="budget_amount !== 0 && !isFinal"
                      small
                      icon
                      @click="editBudgetPlan()"
                    >
                      <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                      ></Iconify>
                    </v-btn>
                  </div>
                  <div class="flex  mt-0.5" style="min-width: 120px; max-width: 120px">
                    แผนการใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px; height: 25px;"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[ind].plan_budget_rate
                        ? budgetPlans[ind].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[currIndex]?.plan_budget_rate
                        ? budgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[shortMonths.length - 1].plan_budget_rate
                        ? budgetPlans[shortMonths.length - 1].plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="mb-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">
                    <v-btn v-if="isFinal" small icon @click="editBudgetPlan()">
                      <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                      ></Iconify>
                    </v-btn>
                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[ind]?.use_budget_rate
                        ? formatNumber(budgetPlans[ind].use_budget_rate, 2)
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            budgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              budgetPlans[currIndex]?.use_budget_rate * 100
                            ) /
                              parseFloat(
                                budgetPlans[currIndex]?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3" v-if="isFinal"></v-divider>

                <div class="d-flex pl-12" v-if="isFinal">
                  ผลการดำเนินงานในภาพรวม ณ ปัจจุบันเป็นร้อยละ
                  <div
                    class="flex tiny-field ml-4"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ formatNumber(regionMonthValue, 2) }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <div v-if="partOneEditMode" id="part-one-edit" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempPlan.p1_activity_name"
              @onChange="tempPlan.p1_actvity_name = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-3">WF</div>

            <TextField
              theme="3"
              input-type="decimal"
              :value="tempPlan.p1_wf"

              :error="error_p1_wf"
              @onChange="tempPlan.p1_wf = $event"
            ></TextField>
          </div>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal-100"
              :error="
                tempPlan.project_section_plan_month[i]?.error ||
                tempPlan.project_section_plan_month[i]?.errorSkipInput
              "
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="
                isFinal
                  ? tempPlan.project_section_plan_month[i]?.actual_month_value
                  : tempPlan.project_section_plan_month[i]?.month_value
              "
              @onChange="validateInput(i, $event)"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partOneEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
      <div
        v-if="partOneBudgetEditMode"
        id="part-one-budget-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          {{ isFinal ? "การใช้จ่ายจริง" : "แผนการใช้จ่าย" }} <span class="theme-color-seven txt-normal" style="margin-left: 22px;">(บาท)</span>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              v-if="isFinal"
              theme="3"
              input-type="decimal"
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.use_budget"
              @onChange="tempBudgetPlan[i].use_budget = $event"
            ></TextField>
            <TextField
              v-else
              theme="3"
              input-type="decimal"
              isFormat
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.plan_budget"
              @onChange="tempBudgetPlan[i].plan_budget = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partOneBudgetEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudgetPlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <!--  FORM 2  -->
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          2. งบประมาณ
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <Button
          v-if="!isFinal"
          theme="6"
          :disabled="partTwoEditMode"
          @onClick="addNewBudget"
        >
          + เพิ่มรายละเอียดงบประมาณ
        </Button>
      </div>

      <div class="card-part">
        <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
          <div style="width: 8%">{{ isFinal ? "" : "จัดการ" }}</div>
          <div style="width: 35%">รายการ</div>
          <div style="width: 29%">รายละเอียด</div>
          <div class="text-end" style="width: 28%">กรอบวงเงินงบประมาณ(บาท)</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div v-for="(item, i) in budgetList" :key="i" class="budget-item">
            <!--            :class="{ 'budget-item-active': item.expanded }"-->
            <div class="d-flex justify-space-between align-center black--text gap-12">
              <div style="width: 8%">
                <v-btn v-if="!isFinal" small icon @click="editBudget(i)">
                  <Iconify
                    icon="material-symbols:edit"
                    color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
                <v-btn v-if="!isFinal" small icon @click="deleteBudget(i)">
                  <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="width: 35%">
                {{ item.budget_name }}
              </div>
              <div style="width: 29%">
                <div style="min-height: 22px; max-height: 22px"></div>
                <div>
                  <div
                    v-for="(detail, ind) in item.form_ab_budget_detail"
                    :key="ind"
                    class="theme-color-eight"
                  >
                    {{ ind + 1 }}. {{ detail.budget_detail_name }}
                  </div>
                </div>
              </div>
              <div class="text-end" style="width: 28%">
                {{ formatNumber(item.budget_amount_rsp, 2) }} บาท
                <div>
                  <div
                    v-for="(detail, ind) in item.form_ab_budget_detail"
                    :key="ind"
                    class="text-end theme-color-eight"
                  >
                    {{ formatNumber(detail.budget_detail_amount, 2) }} บาท
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column gap-12 px-12 my-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">รวม</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  budgetList
                    .map((x) => parseFloat(x.budget_amount_rsp))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="partTwoEditMode && !isFinal"
        id="part-two-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">รายการ</div>

            <TextField
              theme="3"
              style="width: 400px"
              :value="tempBudget.budget_name"
              @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">กรอบวงเงินงบประมาณ(บาท)</div>

            <TextField
              theme="3"
              input-type="decimal"
              :disabled="tempBudget.have_budget_detail"
              :value="tempBudget.budget_amount_rsp"
              isFormat
              @onChange="tempBudget.budget_amount_rsp = $event"
            ></TextField>
          </div>

          <div class="d-flex align-center gap-12">
            <div class="mb-1 pt-1 black--text">รายละเอียด</div>
            <SwitchInset
              :input-value="tempBudget.have_budget_detail"
              :true-value="true"
              :false-value="false"
              @onChange="budgetHasDetail"
            ></SwitchInset>
            <div>{{ tempBudget.have_budget_detail ? "มี" : "ไม่มี" }}</div>
          </div>
        </div>

        <div v-if="tempBudget.have_budget_detail">
          <div class="black--text mb-3">รายละเอียด</div>

          <div class="d-flex flex-column gap-12">
            <div
              v-for="(item, i) in tempBudget.form_ab_budget_detail"
              :key="i"
              class="d-flex align-center gap-16"
            >
              <div>
                <div class="black--text mb-3">ข้อที่ {{ i + 1 }}</div>

                <TextField
                  theme="3"
                  style="width: 400px"
                  :value="item.budget_detail_name"
                  @onChange="item.budget_detail_name = $event"
                ></TextField>
              </div>

              <div>
                <div class="black--text mb-3">กรอบวงเงินงบประมาณ(บาท)</div>

                <TextField
                  theme="3"
                  input-type="decimal"
                  isFormat
                  :value="item.budget_detail_amount"
                  @onChange="editDetailAmount(i, $event)"
                ></TextField>
              </div>

              <v-btn
                v-if="tempBudget.form_ab_budget_detail.length > 1"
                icon
                x-small
                style="background: var(--theme-color-seven)"
                class="mt-1"
                @click="
                  tempBudget.form_ab_budget_detail.splice(i, 1);
                  this.calTempBudgetAmountFromSub();
                "
              >
                <span class="font-type-bold txt-detail white--text pb-1"
                  >x</span
                >
              </v-btn>

              <v-btn
                v-if="i + 1 === tempBudget.form_ab_budget_detail.length"
                icon
                x-small
                style="background: var(--theme-color-two)"
                class="mt-1"
                @click="addBudgetDetail"
              >
                <span class="font-type-bold txt-detail white--text">+</span>
              </v-btn>
            </div>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudget"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          3. กิจกรรมการดำเนินงาน
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <Button theme="6" :disabled="partThreeEditMode" @onClick="addNewEvent">
          + เพิ่มรายละเอียดกิจกรรม
        </Button>
      </div>

      <div class="card-part">
        <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
          <div style="width: 8%">จัดการ</div>
          <div style="width: 35%">รายการ</div>
          <div style="width: 29%">รายละเอียด</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div v-for="(item, i) in OAList" :key="i" class="budget-item">
            <div class="d-flex black--text gap-12">
              <div style="width: 8%">
                <v-btn small icon @click="editOA(i)">
                  <Iconify
                    icon="material-symbols:edit"
                    color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="width: 35%">{{ item.activity }}</div>

              <div
                style="width: 29%"
                v-html="
                  item.description
                    ? item.description.replace(/\n/g, '<br>')
                    : '-'
                "
              >
                <!--              {{item.description}}-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="partThreeEditMode" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div style="min-width: 500px">
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempOA.activity"
              @onChange="tempOA.activity = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex gap-16 mb-3">
          <div style="min-width: 500px">
            <div class="black--text mb-3">รายละเอียด</div>

            <TextArea
              hide-scroll
              theme="3"
              :value="tempOA.description"
              @onChange="tempOA.description = $event"
            ></TextArea>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partThreeEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveOA">ยืนยัน </Button>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";

export default {
  name: "BFormPlan",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempPlan: {},
      tempBudgetPlan: {},
      tempBudget: {
        form_ab_budget_detail: [],
      },
      tempOA: {},
      tempProgressPlan: {},
      partOneEditMode: false,
      partOneBudgetEditMode: false,
      partTwoEditMode: false,
      partThreeEditMode: false,
      expanded: false,
      allPlans: [],
      budgetPlans: [],
      shortMonths: [],
      plan_prototype: {
        p1_wf: "",
        project_section_plan_month: [],
      },
      budget_plan_prototype: [],
      progressPlan_prototype: {
        plan: [],
      },
      error_p1_wf: false,
      allProgressPlan: [],
      budgetList: [],
      OAList: [],
      currIndex: 0,
      allEventsName: [
        "ส่งเสริมคุณภาพการออกแบบและพัฒนา",
        "พัฒนาระบบด้านเทคโนโลยีของหุ่นยนต์",
      ],
      budget_amount: 0,
      fiscalYear: new Date().getFullYear() + 543,
      regionMonthValue: null,
    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.AForm.PlanForm,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    this.clearTempPlan();
    this.clearTempProgressPlan();
    if (this.isSameId && !this.masterData.form_b) this.form = this.PlanForm;
    if (this.masterData.form_b) {
      this.setData();
    }

    this.setupBudgetYearMonth();
    if (this.budgetPlans.length === 0) {
      this.budgetPlans = this.budget_plan_prototype;
    }

    eventBus.$on("bFormPlan", () => {
      eventBus.$emit("bFormPlanSend", {
        ...this.form,
        project_section_plan_p1: this.allPlans.map((x) => ({
          ...x,
          percent: undefined,
        })),
        project_section_plan_p1_budget: this.budgetPlans,
        form_ab_budget: this.budgetList.map((x) => ({
          ...x,
          expanded: undefined,
        })),
        operating_activities: this.OAList,
        budget_amount: this.budget_amount,
      });
    });

    this.currIndex = this.getCurrIndex();
    eventBus.$on("bFormPlanSetData", () => this.setData());
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
      this.allPlans =
        this.masterData.form_b.project_section_plan?.project_plan_p1 || [];
      this.budgetPlans =
        this.masterData.form_b.project_section_plan
          ?.project_section_plan_p1_budget || [];
      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month);
      }
      this.budgetList = this.masterData.form_b.form_ab_budget || [];
      this.OAList = this.masterData.form_b.operating_activities || [];
      this.fiscalYear = this.masterData.form_b.fiscal_year;
      this.regionMonthValue = this.masterData.region_month_value || null;
      this.calcBudgetAmount();
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan();
      if (this.partOneEditMode) {
        this.$vuetify.goTo("#part-one-edit");
      } else {
        this.tempPlan.isNew = true;
        this.partOneEditMode = true;
      }
    },
    editPlan(i) {
      this.partOneEditMode = false;
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i,
      };
      this.partOneEditMode = true;
      this.$forceUpdate();
    },
    deletePlan(i) {
      console.log('deletePlan', i)
      this.allPlans.splice(i, 1);
      this.$forceUpdate();
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal("tempPlan");

      // validate WF
      if (!this.validateWF()) return;

      // validate conditions
      let before_value = 0;
      let error = [];
      let field_name = "month_value";
      for (const x of this.tempPlan.project_section_plan_month) {
        if (this.isFinal) field_name = "actual_month_value";
        if (!isNaN(x[field_name]) && parseFloat(x[field_name]) < before_value) {
          x.error = true;
          if (this.isFinal) {
            error.push(
              "Value must be greater than previous actual month value"
            );
          } else {
            error.push("Value must be greater than previous month value");
          }
        } else {
          x.error = undefined;
          if (x.errorSkipInput) {
            error.push("Cannot skip the input between input values");
          }
        }
        before_value = parseFloat(x[field_name]);
      }
      this.$forceUpdate();
      if (error.length > 0) {
        console.log(error);
        return;
      }

      let lastProgress = this.getLastProgress(
        this.tempPlan.project_section_plan_month
      );
      if (!this.tempPlan.isNew) {
        // EDIT
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_actvity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress,
        });
      }

      this.clearTempPlan();
      this.mapWFData();
      this.partOneEditMode = false;
    },
    mapWFData() {
      this.shortMonths.forEach((m, i) => {
        this.budgetPlans[i].month_value = this.weightPlan(i);
        if (this.isFinal)
          this.budgetPlans[i].actual_month_value = this.weightPlan(
            i,
            "actual_month_value"
          );
      });
    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype);
      this.error_p1_wf = false;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    completeTwoPosDecimal(tempName) {
      let i = 0;
      let temp = [];
      let value = "";
      if (tempName === "tempPlan") {
        temp = this[tempName].project_section_plan_month;
        value = this.isFinal ? "actual_month_value" : "month_value";
      } else {
        temp = this[tempName];
        value = this.isFinal ? "use_budget_rate" : "plan_budget_rate";
      }

      for (const x of temp) {
        x.errorSkipInput = undefined;
        if (!x[value] || isNaN(x[value])) {
          x[value] = null;
          if (i > 0) {
            let hasSomeProgressBefore = false;
            let hasSkipInput = false;
            for (let ind = 0; ind < i; ind++) {
              if (temp[ind][value]) {
                hasSomeProgressBefore = true;
                for (let lastInd = temp.length - 1; lastInd > i; lastInd--) {
                  if (!!temp[lastInd][value]) hasSkipInput = true;
                }
              }
            }

            if (hasSomeProgressBefore) x[value] = "100.00";
            if (tempName === "tempBudgetPlan") x[value] = "0";

            if (hasSkipInput) {
              x[value] = null;
              x.errorSkipInput = true;
            }
          }
        } else {
          // no decimal case
          if (!x[value].toString().includes(".")) {
            x[value] += ".00";
          } else {
            // decimal case
            let y = x[value].toString().split(".");
            if (!y[0] && y[0] != "0") {
              y[0] = "0";
            }
            if (!y[1] && y[1] != "0") {
              y[1] = "00";
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + "0"; // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2);
            }
            x[value] = y[0] + "." + y[1];
            if (x[value] === "0.00") x[value] = null;
          }
        }
        i++;
      }
    },
    validateWF() {
      let error = [];
      let total = 0;
      let editCase =
        !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0;

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf;
          if (editCase) total = 0;
        } else {
          if (editCase) {
            total = this.allPlans
              .filter((x, i) => i !== this.tempPlan.temp_index)
              .map((x) => x.p1_wf)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
          } else {
            total = this.allPlans.reduce(
              (a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf),
              0
            );
          }
        }

        if (parseFloat(total) >= 1) {
          error.push("WF value cannot over exceed 1.00");
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push("WF value is not correct");
      } else {
        // no decimal case
        if (!this.tempPlan.p1_wf.toString().includes(".")) {
          this.tempPlan.p1_wf += ".00";
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split(".");
          if (!y[0] && y[0] != "0") {
            y[0] = "0";
          }
          if (!y[1] && y[1] != "0") {
            y[1] = "00";
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + "0"; // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2);
          }
          this.tempPlan.p1_wf = y[0] + "." + y[1];
          if (this.tempPlan.p1_wf === "0.00") {
            error.push("WF value is not correct");
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push("WF value must less or equal 1.00");
        }
      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push("WF total value must equal 1.00");
      }

      if (error.length > 0) {
        console.log(error);
        this.error_p1_wf = true;
      } else {
        this.error_p1_wf = false;
      }
      this.$forceUpdate();

      return !this.error_p1_wf;
    },
    totalWF() {
      if (!this.allPlans || this.allPlans.length === 0) return "-";
      let total = this.allPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlans) {
        let i = 0;
        // console.log("x", x);
        for (const y of x.project_section_plan_month) {
          // console.log("y", y);
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    addNewBudget() {
      this.tempBudget = {
        form_ab_budget_detail: [],
      };
      if (this.partTwoEditMode) {
        // clear temp index
        // this.clearTempPlan()

        this.$vuetify.goTo("#part-two-edit");
      } else {
        // this.tempPlan.isNew = true
        this.partTwoEditMode = true;
      }
    },
    editBudget(index) {
      this.tempBudget = {
        ...this.removeVModel(this.budgetList[index]),
        temp_index: index,
      };
      this.tempBudget.have_budget_detail =
        this.tempBudget.form_ab_budget_detail.length > 0;
      this.partTwoEditMode = true;
    },
    deleteBudget(index) {
      this.budgetList.splice(index, 1);
      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
    },
    saveBudget() {
      this.partTwoEditMode = false;
      //this.tempBudget.budget_sum = parseFloat(this.tempBudget.budget_in_kind) + parseFloat(this.tempBudget.budget_in_cash) + parseFloat(this.tempBudget.budget_sci_park)
      if (isNaN(this.tempBudget.budget_amount_rsp))
        this.tempBudget.budget_amount_rsp = 0;
      if (!this.tempBudget.have_budget_detail)
        this.tempBudget.form_ab_budget_detail = [];
      if (this.tempBudget.temp_index !== undefined) {
        this.budgetList[this.tempBudget.temp_index] = this.removeVModel(
          this.tempBudget
        );
      } else {
        this.budgetList.push(this.tempBudget);
      }
      this.tempBudget = {};

      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
      this.$forceUpdate();
    },
    editOA(index) {
      console.log("editOA s!!!");
      this.tempOA = {
        ...this.removeVModel(this.OAList[index]),
        temp_index: index,
      };
      this.partThreeEditMode = true;
      console.log("editOA !!!");
    },
    saveOA() {
      this.partThreeEditMode = false;
      if (this.tempOA.temp_index !== undefined) {
        this.OAList[this.tempOA.temp_index] = this.removeVModel(this.tempOA);
      } else {
        this.OAList.push(this.tempOA);
      }
      this.tempOA = {};
    },
    addNewPlanDetail() {
      this.clearTempProgressPlan();
      this.partThreeEditMode = true;
    },
    saveProgressPlan() {
      let error = [];
      if (this.tempProgressPlan.plan.length === 0) {
        error.push("Select at least 1 month for planning");
        return;
      }
      if (this.tempProgressPlan.temp_index !== undefined) {
        // EDIT
        this.allProgressPlan[this.tempProgressPlan.temp_index] = {
          ...this.tempProgressPlan,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allProgressPlan.push(this.tempProgressPlan);
      }
      this.clearTempProgressPlan();
      this.partThreeEditMode = false;
    },
    progressPlanCheck(key) {
      if (this.tempProgressPlan.plan.includes(key)) {
        this.tempProgressPlan.plan = this.tempProgressPlan.plan.filter(
          (x) => x !== key
        );
      } else {
        this.tempProgressPlan.plan.push(key);
      }
    },
    clearTempProgressPlan() {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype);
      this.$forceUpdate();
    },
    editProgressPlan(index) {
      this.partThreeEditMode = false;
      this.tempProgressPlan = {
        ...this.removeVModel(this.allProgressPlan[index]),
        temp_index: index,
      };
      this.partThreeEditMode = true;
      this.$forceUpdate();
    },
    addBudgetDetail() {
      this.tempBudget.form_ab_budget_detail.push({});
    },
    addNewEvent() {
      this.partThreeEditMode = true;
    },
    budgetHasDetail(val) {
      this.tempBudget.budget_amount_rsp = undefined;
      this.tempBudget.have_budget_detail = val;
      this.$forceUpdate();
      if (
        !this.tempBudget.form_ab_budget_detail ||
        this.tempBudget.form_ab_budget_detail.length === 0
      ) {
        this.tempBudget.form_ab_budget_detail = [];
        this.addBudgetDetail();
      }
    },
    expandBudgetItem(i) {
      this.budgetList.forEach((x) => (x.expanded = false));
      this.budgetList[i].expanded = true;
      this.$forceUpdate();
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
        });
        this.budget_plan_prototype.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
          plan_budget: "",
          plan_budget_rate: "",
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    editDetailAmount(i, val) {
      this.tempBudget.form_ab_budget_detail[i].budget_detail_amount = val;
      this.calTempBudgetAmountFromSub();
    },
    calTempBudgetAmountFromSub() {
      this.tempBudget.budget_amount_rsp = this.tempBudget.form_ab_budget_detail
        .map((x) => x.budget_detail_amount)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      this.$forceUpdate();
    },
    calcBudgetAmount() {
      // console.log("budget", this.budgetList);
      this.budget_amount = this.budgetList
        .map((x) => parseFloat(x.budget_amount_rsp))
        .reduce((a, b) => a + b, 0);
      // console.log("budget_amount", this.budget_amount);
    },
    saveBudgetPlan() {
      // // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      // if (
      //   this.tempBudgetPlan.filter((x) => x.plan_budget !== "").length === 0 ||
      //   this.tempBudgetPlan.filter((x) => x.plan_budget != 0).length === 0
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ครบถ้วน ?",
      //     text: "กรุณากรอกข้อมูลอย่างน้อย 1 รายการ และต้องไม่เป็น 0",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      // // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      // if (
      //   this.tempBudgetPlan
      //     .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
      //     .reduce((a, b) => a + b, 0) !==
      //   this.budgetList
      //     .map((x) => parseFloat(x.budget_amount_rsp))
      //     .reduce((a, b) => a + b, 0)
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ถูกต้อง ?",
      //     text: "ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      this.calcBudgetPlanRate();
      // complete 2 pos decimal format
      // this.completeTwoPosDecimal('tempBudgetPlan')

      // validate conditions
      let before_value = 0;
      let totalBudget = 0;
      let error = [];
      for (const x of this.tempBudgetPlan) {
        before_value = parseFloat(x.plan_budget);
        totalBudget += parseFloat(x.plan_budget);
      }
      this.$forceUpdate();
      if (totalBudget > this.budget_amount && !this.isFinal) {
        this.$store.commit("General/setModal", {
          theme: "error",
          title: "บันทึกไม่สำเร็จ",
          text: "แผนการใช้จ่ายเกินงบประมาณ ไม่สามารถบันทึกได้",
          buttonText: "OK",
          showCancel: false,
        });
        return;
      }
      if (error.length > 0) {
        console.log(error);
        return;
      }

      this.budgetPlans = this.tempBudgetPlan;

      this.partOneBudgetEditMode = false;
    },
    editBudgetPlan() {
      this.partOneBudgetEditMode = false;
      this.tempBudgetPlan = this.removeVModel(this.budgetPlans);
      this.partOneBudgetEditMode = true;
      this.$forceUpdate();
    },
    calcBudgetPlanRate(objectName = "tempBudgetPlan") {
      let i = 0;
      let field_name =
        this.isFinal && objectName === "tempBudgetPlan"
          ? "use_budget"
          : "plan_budget";
      this[objectName].forEach((budget) => {
        if (!budget[field_name]) budget[field_name] = 0;
        if (i == 0) {
          budget[field_name + "_sum"] = parseFloat(budget[field_name]);
        } else {
          budget[field_name + "_sum"] =
            parseFloat(budget[field_name]) +
            parseFloat(this[objectName][i - 1][field_name + "_sum"]);
        }
        const exactRate = (parseFloat(budget[field_name + "_sum"]) / parseFloat(this.budget_amount)) * 100;

        budget[field_name + "_rate"] = (Math.floor(exactRate * 100) / 100).toFixed(2);
        budget[field_name + "_sum"] = budget[field_name + "_sum"].toFixed(2);
        i++;
      });
      console.log("after calc budget rate", this.tempBudgetPlan);
    },
    validateInput(index, value) {
      let field_name = "month_value";
      if (this.isFinal) field_name = "actual_month_value";
      if (!isNaN(value) && value >= 0 && value <= 100) {
        // if (index > 0) {
        //   let previousValue = this.tempPlan.project_section_plan_month[index - 1]?.month_value;
        //   if (previousValue && value >= previousValue) {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', value);
        //   } else {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', previousValue);
        //   }
        // } else {
        this.$set(
          this.tempPlan.project_section_plan_month[index],
          field_name,
          value
        );
        // }
      } else {
        if (!isNaN(value)) {
          if (value > 100) {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              100
            );
          } else {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              0
            );
          }
        } else {
          this.$set(
            this.tempPlan.project_section_plan_month[index],
            field_name,
            null
          );
        }
      }
    },
    validatePlanBudget() {
      let isCorrect = true;
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      if (Object.keys(this.budgetPlans).length === 0) {
        return  false;
      }
      if (
        this.budgetPlans?.filter((x) => x.plan_budget !== "")
          .length === 0 ||
        this.budgetPlans?.filter((x) => x.plan_budget != 0)
          .length === 0 ||
        this.budgetPlans?.filter((x) => x.plan_budget != "0.00")
          .length === 0
      ) {
        isCorrect = false;
      }
      // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      if (
        this.budgetPlans
          ?.map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
          .reduce((a, b) => a + b, 0) !==
        this.budgetList
          ?.map((x) => parseFloat(x.budget_amount_rsp))
          .reduce((a, b) => a + b, 0)
      ) {

        isCorrect = false;
      }
      return isCorrect;
    },
      nowIndex(month, year) {
      
        const thaiShortMonthMap = {
          'ม.ค.': 0, 'ก.พ.': 1, 'มี.ค.': 2, 'เม.ย.': 3,
          'พ.ค.': 4, 'มิ.ย.': 5, 'ก.ค.': 6, 'ส.ค.': 7,
          'ก.ย.': 8, 'ต.ค.': 9, 'พ.ย.': 10, 'ธ.ค.': 11
        };
        const monthNumber = thaiShortMonthMap[month];
        if (monthNumber === undefined) return false; // fail-safe

        const buddhistYear = parseInt(year); // 68
        const gregorianYear = buddhistYear + 2000 - 543; // 68 + 2000 - 543 = 1525 (wrong) ❌

        // Correct conversion:
        const currentYear = new Date().getFullYear(); // e.g., 2025
        const buddhistCurrentYear = currentYear + 543; // e.g., 2568

        const yearFull = (buddhistYear > 2500) ? buddhistYear - 543 : buddhistYear + 2500 - 543;
        // Or easier if always 2-digit: assume 68 => 2568 => 2025
        const yearParsed = buddhistYear + 2500 - 543; // 2025

        const planDate = new Date(yearParsed, monthNumber, 1);
        const currentMonthStart = new Date();
        currentMonthStart.setDate(1);
        currentMonthStart.setHours(0, 0, 0, 0);

        return planDate < currentMonthStart;
      }
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
  border: solid 1px transparent;
  cursor: pointer;
}

.budget-item-active {
  border-color: var(--theme-color-seven);
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
